/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-06-05 10:06:34
 * @LastEditors: Please set LastEditors
 */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { envManage } from '../../store/actions';

import { Input, Menu, Dropdown, Button, Tag, Divider } from 'sup-ui';
import CommonModal from 'root/components/CommonModal';
import Icon from 'root/components/Icon';
// import hostPic from 'root/assets/images/standalonesmall@2x.png';

import AddHostForm from './AddHostForm';
import ChangeDeployment from '../ChangeDeployment';

import { deleteNodeApi } from 'root/services/disk';
import { LabelListType, UpdateHostListType } from '../types';
import messages from '../messages';
import styles from './index.less';
import { message } from 'sup-ui';

interface IModalProps {
  visible: boolean;
  type: string; // alone 单机  colony 集群
}

interface IProps {
  list: LabelListType[];
  updateHostList: any;
}

const HostList = (props: IProps) => {
  const intl = useIntl();
  const { list, updateHostList } = props;
  const dispatch = useDispatch();
  const { isSuposInstalled, refersh } = useSelector((state: reducerStates) => state.envManage);
  const [modalProps, setModalProps] = useState<IModalProps>({
    visible: false,
    type: 'alone',
  });
  const [inputValue, setInputValue] = useState('');

  const menu = (
    <Menu
      onClick={({ key }: any) => {
        setModalProps({ visible: true, type: key });
      }}
    >
      <Menu.Item key="alone">+ {intl.formatMessage(messages.aloneAddHost)}</Menu.Item>
      <Menu.Item key="coloy">+ {intl.formatMessage(messages.batchAddHost)}</Menu.Item>
    </Menu>
  );

  const closeModal = () => {
    setModalProps({
      visible: false,
      type: 'alone',
    });
  };

  const getDiffColor = (data: { details: string; message: string; status: string }) => {
    const { status } = data;
    let color = '#0AB129';
    switch (status) {
      case 'DANGER':
        color = '#D20C0C';
        break;
      case 'WARN':
        color = '#D1861B';
        break;
      case 'DEPLOYING':
        color = '#2280FA';
        break;
      default:
        break;
    }

    return color;
  };

  const handleSearchKeyDown = (e: any) => {
    const { keyCode } = e;
    if (keyCode === 13) {
      updateHostList((pre: UpdateHostListType) => ({ ...pre, nameOrIp: inputValue }));
    }
  };

  const handleCheckDetail = (id: string) => {
    dispatch(
      envManage.changeEnvStatus({
        singleNodeId: id, // 运行环境的id
      }),
    );
  };

  const handleDeleteNode = (ids: string[], inUse?: number) => {
    if (inUse) return;
    CommonModal.confirm({
      onOk: () => {
        dispatch(
          envManage.changeEnvStatus({
            colonySpinning: true,
          }),
        );
        deleteNodeEvent(ids);
      },
      title: intl.formatMessage(messages.deleteConfirm),
    });
  };

  const deleteNodeEvent = (ids: string[]) => {
    deleteNodeApi(ids)
      .then(() => {
        message.success(intl.formatMessage(messages.deleteSuccess));
        dispatch(
          envManage.changeEnvStatus({
            refersh: !refersh,
          }),
        );
        updateHostList((pre: UpdateHostListType) => ({ ...pre }));
      })
      .finally(() => {
        dispatch(
          envManage.changeEnvStatus({
            colonySpinning: false,
          }),
        );
      });
  };

  return (
    <div className={styles.host_list}>
      <div className={styles.search}>
        <div className={styles.search_title}>
          {intl.formatMessage(messages.hostNode)}({list.length})
        </div>
        <Input
          style={{ width: 276 }}
          onChange={(e: any) => setInputValue(e.target.value)}
          onKeyDown={handleSearchKeyDown}
          placeholder={intl.formatMessage(messages.searchTip)}
        />
        <div className={styles.search_btn}>
          <Dropdown overlay={menu} trigger={['click']}>
            <span>
              {intl.formatMessage(messages.addNode)}{' '}
              <Icon type="bluearrow16_down" style={{ fontSize: 12, color: '#fff' }} />
            </span>
          </Dropdown>
          <Button
            disabled={isSuposInstalled || list.length === 0}
            onClick={() => handleDeleteNode(list.map((item) => item.id))}
          >
            {intl.formatMessage(messages.deleteAll)}
          </Button>
        </div>
      </div>
      <div className={styles.content}>
        {list.map((item) => (
          <div key={item.id} className={styles.hostItem}>
            <Icon type="disconnect16" style={{ fontSize: 16, color: getDiffColor(item.status) }} />
            <ul className={styles.hostItem_detail}>
              <li className={styles.hostName}>
                <span className={styles.firstChild}>{item.name}</span>
                <span className={styles.linkStatus} style={{ color: getDiffColor(item.status) }}>
                  {item.status.message}
                </span>
              </li>
              <li className={styles.ip}>IP: {item.ip}</li>
              <li>
                <div className={styles.tag}>
                  {!item.inUse && <Tag color="blue">{intl.formatMessage(messages.notUsed)}</Tag>}
                  {item.labels.map((ele, index) =>
                    ele && ((item.inUse && index < 3) || (!item.inUse && index < 2)) ? (
                      <Tag key={ele} color="blue" style={{ display: 'inline-block', width: 70, textAlign: 'center' }}>
                        {ele}
                      </Tag>
                    ) : null,
                  )}
                </div>

                {(item.inUse && item.labels.length > 3) || (!item.inUse && item.labels.length > 2) ? (
                  <span>...</span>
                ) : null}
                {/* <img className={styles.img} alt="" src={hostPic} /> */}
              </li>
            </ul>
            {item?.status?.status !== 'DEPLOYING' && (
              <div className={styles.oprerate}>
                <span onClick={() => handleCheckDetail(item.id)}>{intl.formatMessage(messages.viewDetail)}</span>
                <Divider type="vertical" />
                <span
                  onClick={() => handleDeleteNode([item.id], item.inUse)}
                  className={item.inUse ? styles.disableDelete : styles.delete}
                >
                  {intl.formatMessage(messages.delete)}
                </span>
              </div>
            )}
          </div>
        ))}
        <ChangeDeployment />
      </div>

      <AddHostForm {...modalProps} updateHostList={updateHostList} onOk={closeModal} />
    </div>
  );
};

export default HostList;
